import styled from '@emotion/styled';

export const OptionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
